exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".primary-theme-button button{background-color:#0c337e!important;border-color:#0c337e!important}.primary-theme-button button:hover:not(:disabled){background-color:rgb(8.452173913,35.9217391304,88.747826087)!important;border-color:rgb(8.452173913,35.9217391304,88.747826087)!important}.primary-theme-button button:active:not(:disabled){background-color:rgb(5.347826087,22.7282608696,56.152173913)!important;border-color:rgb(5.347826087,22.7282608696,56.152173913)!important}.primary-theme-button button:disabled{opacity:.5}", ""]);

// exports
